module.exports = __webpack_public_path__ + "img/preview_file.ef116da5.png";